import { render } from "./App.vue?vue&type=template&id=2b6a43c3"
const script = {}

import exportComponent from "/Volumes/data/dev/projects/huasisoft/official-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__